export default import.meta.ROLLUP_FILE_URL_DQR9D$DD;